import theme from 'theme'

const LabelPinIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M11.9943 11.3141L14.9566 7.13864L12.7922 4.9743L8.61681 7.93659C8.13462 7.4544 7.38604 7.3625 6.80153 7.71374L6.36018 7.97895C6.04919 8.16582 5.99723 8.59546 6.25466 8.85113L7.99341 10.5777L9.4849 12.0588L11.0987 13.6614C11.3555 13.9164 11.7835 13.8624 11.969 13.5517L12.2219 13.1281C12.5706 12.544 12.4778 11.7976 11.9968 11.3166L11.9943 11.3141Z"
        fill={theme.colors.white}
      />
      <path
        d="M12.7922 4.9743L14.9566 7.13864L15.1554 7.33752C15.5614 7.74353 16.2197 7.74353 16.6257 7.33752C17.0317 6.93151 17.0317 6.27326 16.6257 5.86725L14.063 3.30451C13.657 2.8985 12.9987 2.8985 12.5927 3.30451C12.1867 3.71052 12.1867 4.36877 12.5927 4.77478L12.7922 4.9743Z"
        fill={theme.colors.white}
      />
      <path
        d="M4.86667 16.0667C4.42849 16.5048 3.63585 16.7241 3.06737 16.9708L3 17C3.24789 16.3704 3.3451 15.4196 3.82353 14.9412L6.5 12L8 13.5L4.86667 16.0667Z"
        fill={theme.colors.white}
      />
      <path
        d="M14.9566 7.13864L11.9943 11.3141L11.9968 11.3166C12.4778 11.7976 12.5706 12.544 12.2219 13.1281L11.969 13.5517C11.7835 13.8624 11.3555 13.9164 11.0987 13.6614M14.9566 7.13864L12.7922 4.9743M14.9566 7.13864L15.1554 7.33752M12.7922 4.9743L8.61681 7.93659C8.13462 7.4544 7.38604 7.3625 6.80153 7.71374L6.36018 7.97895C6.04919 8.16582 5.99723 8.59546 6.25466 8.85113M12.7922 4.9743L12.5927 4.77478M6.25466 8.85113L11.0987 13.6614M6.25466 8.85113L7.99341 10.5777L9.4849 12.0588L11.0987 13.6614M15.1554 7.33752L12.5927 4.77478M15.1554 7.33752C15.5614 7.74353 16.2197 7.74353 16.6257 7.33752C17.0317 6.93151 17.0317 6.27326 16.6257 5.86725L14.063 3.30451C13.657 2.8985 12.9987 2.8985 12.5927 3.30451C12.1867 3.71052 12.1867 4.36877 12.5927 4.77478M4.86667 16.0667C4.42849 16.5048 3.63585 16.7241 3.06737 16.9708L3 17C3.24789 16.3704 3.3451 15.4196 3.82353 14.9412L6.5 12L8 13.5L4.86667 16.0667Z"
        stroke={theme.colors.white}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LabelPinIcon
